import { render, staticRenderFns } from "./EnacCustomBehaviouralIndicatorEditForm.vue?vue&type=template&id=5399e874"
import script from "./EnacCustomBehaviouralIndicatorEditForm.vue?vue&type=script&lang=js"
export * from "./EnacCustomBehaviouralIndicatorEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports